const { InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow, ToggleControl } = wp.components;
import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';
import SelectBackground from '../wp-controlers/select-background';

const Inspector = ({ attributes, setAttributes }) => {
  const { hasMobileImage, fullHeight } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do Bloco" initialOpen={true}>
        <SelectBackground
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </PanelBody>

      <PanelBody title="Atributos da Imagem" initialOpen={true}>
        <PanelRow>
          <p>Imagem do background desktop:</p>
        </PanelRow>
        <PanelRow>
          <ImageControl
            image="backgroundImg"
            attributes={attributes}
            setAttributes={setAttributes}
          />
        </PanelRow>

        <ToggleControl
          label="Adicionar imagem de fundo no mobile?"
          checked={hasMobileImage}
          onChange={() => setAttributes({ hasMobileImage: !hasMobileImage })}
        />

        {hasMobileImage && (
          <>
            <PanelRow>
              <p>Imagem do background mobile</p>
            </PanelRow>

            <PanelRow>
              <ImageControl
                image="backgroundImgMobile"
                attributes={attributes}
                setAttributes={setAttributes}
              />
            </PanelRow>
          </>
        )}

        <ToggleControl
          label="Altura da imagem acompanhando a seção:"
          checked={fullHeight}
          onChange={() => setAttributes({ fullHeight: !fullHeight })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
